import { Permission } from 'api';
import { RouteDefinition } from './types';

export const getBulkActionsRoutes = (basePath: string) => ({
  path: basePath,
  requiresAny: [
    Permission.ImportCertifications,
    Permission.ImportExaminerCentres,
    Permission.ImportExaminerContactDetails,
    Permission.ImportExaminerRoles,
    Permission.ImportMonitorings,
    Permission.ImportTrainings,
  ],
  trainingAndStandardisationSessions: {
    to: `${basePath}/trainingAndStandardisationSessions`,
    path: `trainingAndStandardisationSessions`,
    requiresAll: [Permission.ImportTrainings],
  } as RouteDefinition,
  speakingMonitorings: {
    to: `${basePath}/speakingMonitorings`,
    path: `speakingMonitorings`,
    requiresAll: [Permission.ImportMonitorings],
  } as RouteDefinition,
  osmMonitoringResults: {
    to: `${basePath}/osmMonitoringResults`,
    path: `osmMonitoringResults`,
    requiresAll: [Permission.ImportMonitorings],
  } as RouteDefinition,
  osmMonitoringArchiving: {
    to: `${basePath}/osmMonitoringArchiving`,
    path: `osmMonitoringArchiving`,
    requiresAll: [Permission.ImportMonitorings],
  } as RouteDefinition,
  examinerRoles: {
    to: `${basePath}/examinerRoles`,
    path: `examinerRoles`,
    requiresAll: [Permission.ImportExaminerRoles],
  } as RouteDefinition,
  examinerContactDetails: {
    to: `${basePath}/examinerContactDetails`,
    path: `examinerContactDetails`,
    requiresAll: [Permission.ImportExaminerContactDetails],
  } as RouteDefinition,
  examinerCentres: {
    to: `${basePath}/examinerCentres`,
    path: `examinerCentres`,
    requiresAll: [Permission.ImportExaminerCentres],
  } as RouteDefinition,
  speakingCertifications: {
    to: `${basePath}/speakingCertifications`,
    path: `speakingCertifications`,
    requiresAll: [Permission.ImportCertifications],
  } as RouteDefinition,
  writingCertifications: {
    to: `${basePath}/writingCertifications`,
    path: `writingCertifications`,
    requiresAll: [Permission.ImportCertifications],
  } as RouteDefinition,
  odpAssessments: {
    to: `${basePath}/odpAssessments`,
    path: `odpAssessments`,
    requiresAll: [Permission.ImportOdpAssessmentAndMonitoring],
  } as RouteDefinition,
  odpMonitorings: {
    to: `${basePath}/odpMonitorings`,
    path: `odpMonitorings`,
    requiresAll: [Permission.ImportOdpAssessmentAndMonitoring],
  } as RouteDefinition,
});
